import { Link } from "react-router-dom";
import { Clock, Mail, MapPin, ReceiptText } from "lucide-react";
import { SOLUTIONS } from "../../lib/solutionsContent";
import { LEGAL_DOCS } from "../../lib/legalContent";
import { COMPANY_LEGAL } from "../../lib/companyLegalInfo";
import { openCookieSettings } from "../../lib/cookieConsent";
import { BrandLogo } from "../BrandLogo";

const filled = (value, placeholder) => (value && value.trim() ? value.trim() : placeholder);

const RESOURCES = [
  { label: "Prezzi", href: "#prezzi" },
  { label: "Come funziona", href: "#come-funziona" },
  { label: "Confronto con Excel e ERP", href: "#confronto" },
  { label: "Domande frequenti", href: "#faq" },
  { label: "Richiedi una demo", href: "#demo" },
];

export function LandingFooter({ onNavigate }) {
  return (
    <footer className="landing-footer-full" data-testid="landing-footer">
      <div className="landing-footer-grid">
        <div className="landing-footer-brand">
          <BrandLogo size={44} className="landing-brand-logo" />
          <p className="landing-footer-claim">
            <b>Officina Tool Control</b><br />
            PLM per officine di meccanica di precisione: utensili, magazzino, acquisti, produzione, qualità
            e preventivi in un unico posto.
          </p>
          <Link
            className="landing-login-btn"
            to="/registra-azienda"
            onClick={onNavigate("/registra-azienda")}
            data-testid="footer-cta-register"
          >
            Prova gratis
          </Link>
        </div>

        <nav className="landing-footer-col" aria-label="Moduli">
          <p className="landing-footer-title">Moduli</p>
          {SOLUTIONS.map((solution) => (
            <Link key={solution.slug} to={solution.path} data-testid={`footer-solution-${solution.slug}`}>
              {solution.nav}
            </Link>
          ))}
        </nav>

        <nav className="landing-footer-col" aria-label="Risorse">
          <p className="landing-footer-title">Risorse</p>
          <Link to="/blog" data-testid="footer-blog">Guide e blog</Link>
          {RESOURCES.map((entry) => (
            <a key={entry.href} href={entry.href}>{entry.label}</a>
          ))}
          <Link to="/login" onClick={onNavigate("/login")} data-testid="footer-login">Accedi</Link>
        </nav>

        <div className="landing-footer-col">
          <p className="landing-footer-title">Contatti</p>
          <p className="landing-footer-contact" data-testid="footer-contacts">
            <span><Mail size={13} />{filled(COMPANY_LEGAL.supportEmail, "info@toolsvalue.com")}</span>
            <span><Clock size={13} />Assistenza lunedì-venerdì, 9:00-18:00</span>
            <span><MapPin size={13} />{filled(COMPANY_LEGAL.address, "Vicenza · Italia")}</span>
            <span><ReceiptText size={13} />
              {filled(COMPANY_LEGAL.legalName, "ToolsValue")} · P. IVA{" "}
              {filled(COMPANY_LEGAL.vatNumber, "in corso di registrazione")}
            </span>
          </p>
          <p className="landing-footer-note">
            Rispondiamo alle richieste di demo entro un giorno lavorativo.
          </p>
        </div>
      </div>

      <div className="landing-footer-bottom">
        <span>© {new Date().getFullYear()} ToolsValue · Officina Tool Control</span>
        <nav className="landing-footer-links">
          {LEGAL_DOCS.map((entry) => (
            <Link key={entry.slug} to={entry.path} data-testid={`landing-${entry.slug}-link`}>{entry.title}</Link>
          ))}
          <button type="button" onClick={openCookieSettings} data-testid="landing-cookie-settings">
            Impostazioni cookie
          </button>
        </nav>
      </div>
    </footer>
  );
}
